import { render, staticRenderFns } from "./cufds.vue?vue&type=template&id=72ff6bfe"
import script from "./cufds.vue?vue&type=script&lang=js"
export * from "./cufds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports